const ufeApi = require('services/api/ufeApi');

//https://confluence.sephora.com/wiki/display/ILLUMINATE/Get+BI+Profile+API

function getBiProfile(profileId) {
    const url = `/api/bi/profiles/${profileId}/beautyInsiderAccount`;

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = getBiProfile;
